import { render, staticRenderFns } from "./detailVoucher.vue?vue&type=template&id=201b515e"
import script from "./detailVoucher.vue?vue&type=script&lang=js"
export * from "./detailVoucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports